module.exports = __webpack_public_path__ + "static/media/regua-realizacao.e190568d.png";